import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { AbilityOverridesState } from './types';

export const useAbilityOverrides = create<AbilityOverridesState>()(
  persist(
    (setState, getState) => ({
      overrides: {},
      globalOverride: undefined,
      getIsActive: () =>
        getState().globalOverride !== undefined ||
        Object.values(getState().overrides).filter((v) => v !== undefined)
          .length > 0,
      override: (subject, action, enabled) =>
        setState((state) => {
          return {
            ...state,
            overrides: {
              ...state.overrides,
              [subject]: {
                ...state.overrides[subject],
                [action]: enabled,
              },
            },
            globalOverride: undefined,
          };
        }),
      clearOverride: (subject, action) =>
        setState((state) => {
          if (action) {
            // Clear specific action for the subject
            const subjectOverrides = { ...state.overrides[subject] };
            delete subjectOverrides[action];

            // If no more actions for this subject, remove the subject entirely
            const hasRemainingActions =
              Object.keys(subjectOverrides).length > 0;

            return {
              ...state,
              overrides: {
                ...state.overrides,
                [subject]: hasRemainingActions ? subjectOverrides : undefined,
              },
              globalOverride: undefined,
            };
          } else {
            // Clear all actions for the subject
            const newOverrides = { ...state.overrides };
            delete newOverrides[subject];
            return {
              ...state,
              globalOverride: undefined,
              overrides: newOverrides,
            };
          }
        }),
      setGlobalOverride: (enabled) =>
        setState((state) => ({
          ...state,
          globalOverride: enabled,
        })),
      clearGlobalOverride: () =>
        setState((state) => {
          return {
            ...state,
            globalOverride: undefined,
          };
        }),
      clearAll: () =>
        setState((state) => ({
          ...state,
          overrides: {},
          globalOverride: undefined,
        })),
    }),
    {
      name: 'ability-overrides',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
